// @flow
import dp2_5l1q1 from './l1q1';
import dp2_5l1q2 from './l1q2';
import dp2_5l1q3 from './l1q3';
import dp2_5l1q4 from './l1q4';
import dp2_5l1q5 from './l1q5';
import dp2_5l3q1 from './l3q1';
import dp2_5l3q2 from './l3q2';
import dp2_5l3q3 from './l3q3';
import dp2_5l3q4 from './l3q4';
import dp2_5l3q5 from './l3q5';
import dp2_5l3q6 from './l3q6';
import dp2_5l5q1 from './l5q1';
import dp2_5l5q2 from './l5q2';
import dp2_5l5q3 from './l5q3';
import dp2_5l5q4 from './l5q4';
import dp2_5l5q5 from './l5q5';
import dp2_5l5q6 from './l5q6';
import dp2_5l5q7 from './l5q7';
import dp2_5l5q8 from './l5q8';
import dp2_5l7q1 from './l7q1';
import dp2_5l7q2 from './l7q2';
import dp2_5l7q3 from './l7q3';

const questions = {
    dp2_5l1q1,
    dp2_5l1q2,
    dp2_5l1q3,
    dp2_5l1q4,
    dp2_5l1q5,
    dp2_5l3q1,
    dp2_5l3q2,
    dp2_5l3q3,
    dp2_5l3q4,
    dp2_5l3q5,
    dp2_5l3q6,
    dp2_5l5q1,
    dp2_5l5q2,
    dp2_5l5q3,
    dp2_5l5q4,
    dp2_5l5q5,
    dp2_5l5q6,
    dp2_5l5q7,
    dp2_5l5q8,
    dp2_5l7q1,
    dp2_5l7q2,
    dp2_5l7q3
}
export default questions;



// WEBPACK FOOTER //
// ./src/constants/dp/questions/cat2.5/index.js